(($) => {
    const eqHeightGroups = [];
    const eqWidthGroups = [];

    window.addEventListener('load', init);

    function init() {
        const $eqH = $('[class*="eq-h-"]');
        const $eqW = $('[class*="eq-w-"]');

        if ($eqH.length == 0 && $eqW.length == 0) {
            return null;
        }

        $eqH.each((i) => {
            const classes = $eqH.eq(i).attr('class').split(/\s+/);
            // Find the matching eq-h-* class
            $.each(classes, function(c, className) {
                if (className.match(/^eq-h-.*$/)) {
                    if (!eqHeightGroups[className]) {
                        eqHeightGroups[className] = [];
                    }
                    eqHeightGroups[className].push($eqH.eq(i));
                }
            });
        });

        $eqW.each((i) => {
            const classes = $eqW.eq(i).attr('class').split(/\s+/);
            // Find the matching eq-w-* class
            $.each(classes, function(c, className) {
                if (className.match(/^eq-w-.*$/)) {
                    if (!eqWidthGroups[className]) {
                        eqWidthGroups[className] = [];
                    }
                    eqWidthGroups[className].push($eqH.eq(i));
                }
            });
        });

        setEqualDimensions();
        bind();
        
    }

    function bind() {
        $(window).on('resize', onWindowResize);
    }

    function setEqualDimensions() {
        setEqualHeights();
        setEqualWidths();
    }

    function setEqualHeights() {
        for (let groupName in eqHeightGroups) {
            let maxHeight = 0;
            let groupElements = eqHeightGroups[groupName];

            for (let i = 0; i < groupElements.length; i++) {
                groupElements[i].height('');
            }
            
            for (let i = 0; i < groupElements.length; i++) {
                let oHeight = groupElements[i].outerHeight();
                if (oHeight  > maxHeight) {
                    maxHeight = oHeight;
                }
            }

            for (let i = 0; i < groupElements.length; i++) {
                let pTop = Number(groupElements[i].css('padding-top').replace('px', ''));
                let pBottom = Number(groupElements[i].css('padding-bottom').replace('px', ''));

                groupElements[i].height(maxHeight - pTop - pBottom);
            }
        }
    }

    function setEqualWidths() {
        for (let groupName in eqWidthGroups) {
            let maxWidth = 0;
            let groupElements = eqWidthGroups[groupName];

            for (let i = 0; i < groupElements.length; i++) {
                groupElements[i].width('');
            }
            
            for (let i = 0; i < groupElements.length; i++) {
                let oWidth = groupElements[i].outerWidth();
                if (oWidth  > maxWidth) {
                    maxWidth = oWidth;
                }
            }

            for (let i = 0; i < groupElements.length; i++) {
                let pLeft = Number(groupElements[i].css('padding-left').replace('px', ''));
                let pRight = Number(groupElements[i].css('padding-right').replace('px', ''));

                groupElements[i].width(maxWidth - pLeft - pRight);
            }
        }
    }

    function onWindowResize(event) {
        if (!(event.originalEvent instanceof Event)) {
			return null;
		}

        setEqualDimensions();
    }
})(jQuery);